// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");
let WizardPhotosAndFiles = require("../wizard/WizardPhotosAndFiles.bs.js");

function PropertyWizardRelay__PhotosAndFiles(props) {
  return JsxRuntime.jsx(WizardPhotosAndFiles.make, {
    imagesManager: props.imagesManager,
    filesManager: props.filesManager
  });
}

let make = PropertyWizardRelay__PhotosAndFiles;

exports.make = make;
/* react/jsx-runtime Not a pure module */
